__turbopack_context__.v({
  "link": "B7NiHq_link",
  "list": "B7NiHq_list",
  "root": "B7NiHq_root",
  "selected": "B7NiHq_selected",
});
